// Sticky lifecycle flags on the PostHog person profile. They answer "has this
// merchant ever done X" — never "are they doing X now" — so once raised they
// are never lowered, even if the store is deleted or WhatsApp is disconnected.
// That keeps cohorts stable: a merchant cannot silently drop out of a funnel
// they already completed.
export const PROFILE_FLAG = {
  has_visited_demo_store: 'has_visited_demo_store',
  has_created_real_store: 'has_created_real_store',
  has_ever_visited_real_store: 'has_ever_visited_real_store',
  has_onboarded: 'has_onboarded',
} as const

export type ProfileFlag = (typeof PROFILE_FLAG)[keyof typeof PROFILE_FLAG]

export const PROFILE_FLAGS: ProfileFlag[] = Object.values(PROFILE_FLAG)

// Which flags have already been sent for the agent on this browser. Purely a
// de-duplication cache so a flag costs one request per agent, not one per
// render — PostHog itself is the source of truth.
export const PROFILE_FLAG_STORAGE_KEY = 'zoko_profile_flags'
